module.exports = __webpack_public_path__ + "static/COVID-DTC-Box-Image-bdf1a3681aab0b3546b08c3a59b39dc3.png";